import lazyLoad from "@loadable/component";
import createPlugin from "./createPlugin";
import InfoPanelRenderer from "./Renderer";

const InfoPanelForm = lazyLoad(() => import("./Form"));

const InfoPanelPlugin = (settings) =>
    createPlugin({
        Renderer: InfoPanelRenderer,
        Controls: InfoPanelForm,
        ...settings,
    });

const InfoPanel = InfoPanelPlugin();
export default InfoPanel;

export { InfoPanelPlugin, InfoPanelRenderer };
